
import React from "react";
import { Button } from "@/components/ui/button";
import { SearchX, BookOpen } from "lucide-react";
import { Link } from "react-router-dom";

interface NoResultsArticlesProps {
  searchTerm: string;
  onClearSearch: () => void;
}

const NoResultsArticles: React.FC<NoResultsArticlesProps> = ({ searchTerm, onClearSearch }) => {
  // Recommended articles when no search results are found
  const recommendedArticles = [
    { slug: "armpit-health-basics", title: "Armpit Health: The Basics Everyone Should Know" },
    { slug: "understanding-armpit-pain", title: "Understanding Armpit Pain" },
    { slug: "the-ultimate-deodorant-guide", title: "The Ultimate Deodorant Guide" }
  ];
  
  return (
    <div className="py-16 text-center">
      <div className="mb-8 inline-flex justify-center items-center p-6 bg-muted/50 rounded-full">
        <SearchX size={36} className="text-muted-foreground" />
      </div>
      <h3 className="text-2xl font-semibold mb-3">No Articles Found</h3>
      <p className="text-muted-foreground mb-8 max-w-md mx-auto">
        We couldn't find any articles matching "{searchTerm}". Try adjusting your search or explore our recommended articles below.
      </p>
      
      <Button onClick={onClearSearch} variant="outline" className="button-hover mb-12">
        Clear Search
      </Button>
      
      <div className="border-t border-border pt-12">
        <h4 className="text-xl font-medium mb-6 flex items-center justify-center">
          <BookOpen size={20} className="mr-2" />
          Recommended Articles
        </h4>
        <div className="flex flex-col gap-4 max-w-lg mx-auto">
          {recommendedArticles.map((article) => (
            <Link 
              key={article.slug} 
              to={`/article/${article.slug}`}
              className="p-4 border border-border rounded-lg hover:bg-muted/50 transition-colors text-left"
            >
              <span className="font-medium">{article.title}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NoResultsArticles;
